// src/oura/merchant/workDates.ts
//
// What Our work and Home group the work by, and how they say a date
// (27 Oct 2026). The marks that draw them are in WorkMarks.tsx.

/** The areas a client recognises, in reading order. */
export const WORK_AREAS: { key: WorkArea; label: string }[] = [
    { key: "site", label: "Your website" },
    { key: "pages", label: "New pages" },
    { key: "google", label: "Google and listings" },
    { key: "reports", label: "Checks and reports" },
    { key: "other", label: "Other work" },
];
export type WorkArea = "site" | "pages" | "google" | "reports" | "other";

/** A catalogue code's area. A code the catalogue does not know is custom work: Other work. */
export function areaOf(code: string): WorkArea {
    const c = code.trim().toUpperCase();
    if (["S1", "S3", "S6", "S7", "A2", "A3", "G2"].includes(c)) return "site";
    if (["B1", "G1", "G5"].includes(c)) return "pages";
    if (["S2", "S4", "S5"].includes(c)) return "google";
    if (["A1", "A4", "G3", "G4", "G6", "G7", "G8"].includes(c)) return "reports";
    return "other";
}

export const MONTH = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const WEEKDAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/** "2026-10-02" (or anything Date reads) as a local calendar day; null when unreadable. */
export function calendarDay(value: string | null | undefined): Date | null {
    if (!value) return null;
    const ymd = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (ymd) {
        // A day that does not exist ("2026-02-31") is unknown, never rolled into March.
        const d = new Date(+ymd[1], +ymd[2] - 1, +ymd[3]);
        return d.getFullYear() === +ymd[1] && d.getMonth() === +ymd[2] - 1 && d.getDate() === +ymd[3] ? d : null;
    }
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

/** "Fri". */
export function weekday(d: Date): string {
    return WEEKDAY[d.getDay()];
}

/** "Fri 9 Oct". */
export function shortDay(d: Date): string {
    return `${WEEKDAY[d.getDay()]} ${d.getDate()} ${MONTH[d.getMonth()]}`;
}

